var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_vm._v("暂无数据")])
}
var staticRenderFns = []

export { render, staticRenderFns }